module.exports = __webpack_public_path__ + "img/snowflake-02.013d4cb1.svg";